import type { Dispatch } from 'redux';

import { FORM_DATA_AD_EXPIRY_DATE } from 'src/app/shared/constants/dispatcherId';
import { log } from 'src/app/utils/logging';
import { actionUpdateExpiryDate } from 'src/app/v1/state/modules/formData/expiryDate';

export default (dispatcherId: string, value: any) => (dispatch: Dispatch) => {
  if (value === undefined) {
    log.error('FormData | Undefined value attempting to be dispatched', {
      dispatcherId,
    });
    return;
  }

  switch (dispatcherId) {
    case FORM_DATA_AD_EXPIRY_DATE: {
      log.info('Set ExpiryDate in UI', value);
      return dispatch(actionUpdateExpiryDate(value));
    }

    default: {
      return null;
    }
  }
};
